import React from 'react'
import styles from './IconBrowser.module.scss'

export default function IconBrowser() {
    return <div className={styles.root} />
}
